export enum View {
  Card = 'card',
  List = 'list',
}
